<div mat-dialog-title>
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 animate__animated animate__fadeIn"
    style="position: relative;margin-top: 20px;">
    <div class="close-dialog" mat-dialog-close>
      <i class="fa-regular fa-xmark"></i>
    </div>
  </div>
</div>

<div mat-dialog-content>
  <div class="titulo-card">
    agrega las facturas para generar tu simulación de factoring
  </div>

  <div class="imagen-final">
    <img src="../../assets/iconografia/Iconografia - Development(3).png" style="height: 160px !important;">
  </div>

  <div class="footer-botones">
    <span (click)="open_modal_info(31)">¿Qué es una simulación de factoring?</span>
  </div>

  <div class="caja-botones mt-20">

    <button mat-stroked-button class="primary-button" (click)="open_agregar_facturas()">Agregar facturas</button>
    <button mat-stroked-button class="secondary-button" (click)="open_agregar_facturas_by_nomina();">Cargar nómina de
      facturas</button>
  </div>


</div>